import React from "react";
import { DiscussonDetail } from "./discussonDetail";
class DiscussonDetailParent extends React.Component {
    render() {
        return (
            <DiscussonDetail {...this.props} />
        )
    }
}
export default DiscussonDetailParent